module.exports = __webpack_public_path__ + "static/traditions-technology-boost-bee-health-6545f325dfe7ed8f0c3ce824aa944cee.jpg";